module.exports = __webpack_public_path__ + "img/zuoriwancheng.42924294.jpg";